import {BaseAnalyticsEvent} from "../../infrastructure/models/analytics/base-analytics-event";

export class SearchDisplayEvent extends BaseAnalyticsEvent {

  constructor(params) {
    super('', 'display', 'search-tool');

  }

  get properties() {
    const properties = super.properties;

    return properties;
  }
}
